import React from 'react';
import './svg.css';

const NewDownloadSpeedIcon = () => {
  return (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" fill="white" />
      <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" stroke="#C9CCD4" strokeWidth="0.6" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5 7C12.5 6.72386 12.2761 6.5 12 6.5C11.7239 6.5 11.5 6.72386 11.5 7V13.5273L9.45121 11.4785C9.25595 11.2832 8.93936 11.2832 8.7441 11.4785C8.54884 11.6737 8.54884 11.9903 8.7441 12.1856L11.6441 15.0856C11.68 15.1215 11.72 15.1508 11.7625 15.1735C11.8332 15.2116 11.9141 15.2333 12 15.2333C12.1564 15.2333 12.296 15.1615 12.3877 15.0491L15.2512 12.1856C15.4465 11.9903 15.4465 11.6737 15.2512 11.4785C15.0559 11.2832 14.7394 11.2832 14.5441 11.4785L12.5 13.5226V7Z" fill="url(#paint0_radial_5148_1270)" />
      <path d="M19.25 14.7344V15.701C19.25 16.7688 18.3844 17.6344 17.3167 17.6344H6.68333C5.61558 17.6344 4.75 16.7688 4.75 15.701V14.7344" stroke="url(#paint1_radial_5148_1270)" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <radialGradient id="paint0_radial_5148_1270" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.1045 17.5215) rotate(-127.782) scale(16.2214 53.4401)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient id="paint1_radial_5148_1270" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(22.8895 18.3942) rotate(-168.641) scale(21.6151 28.3971)">
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>

  )
}

export default NewDownloadSpeedIcon;